import createRangeSelectFilter from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/RangeSelectFilter/factory";

import { DOLLAR_PREFIX } from "../../constants/index";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { formatMoney } from "../../utils/numberFormatters";
import { defineDescriptionFilter } from "../defineSourcedFilter";

export const usdSpendDefinition = defineDescriptionFilter({
    key: "usdSpend",
    apiCategory: leadsFilterApiCategory.usdSpend,
    category: leadsFilterCategoryMap.trafficAndEngagement,
    trackingName: "PPC Spend",

    render: ({ description }) =>
        createRangeSelectFilter({
            key: "usdSpend",
            trackingName: "PPC Spend",
            apiCategory: "leadsFilters",
            category: leadsFilterCategoryMap.trafficAndEngagement,

            translationKey: "usd_spend",
            rangeOptions: {
                fieldName: "usdSpend",
                buckets: description.bucketsDescription.usdSpend,
                placeholderPrefix: DOLLAR_PREFIX,
                formatValue: formatMoney,
            },
        }),
});
